<script lang="ts">
  import { onMount, tick } from 'svelte';
  import type { UserEvent } from '../../lib/pandalytics';
  import { queryUserEvents } from '../../lib/pandalytics';
  import { UserService } from '../../modules';
  import Lazy from 'svelte-lazy';
  import type { User } from '../../modules/user/user.interface';
  import Page from '../Page.svelte';
  import Scroller from '../Scroller.svelte';
  import EventTable from './EventTable.svelte';

  export let params: { project: string; userId: string };

  let user: User;
  let events: UserEvent[] = [];
  let page = 1;
  let limit = 50;
  let message = '';
  let userTitle = '';
  let disableLazy = false;
  let isLoading = false;

  onMount(fetchUser);

  async function fetchUser() {
    user = await UserService.getUserById(parseInt(params.userId));
    userTitle = `${user.username}-${user.email}`;
    fetchEvents();
  }

  async function fetchEvents() {
    isLoading = true;

    try {
      const result = await queryUserEvents({
        project: params.project,
        userId: user.id,
        page,
        limit,
      });

      events = [...events, ...result.docs];
      await tick();
      disableLazy = false;
      if (!result.docs?.length) {
        message = 'No Events!';
        return;
      }

      message = '';
    } catch (error) {}
    isLoading = false;
  }

  function onScrollEnded() {
    page++;
    fetchEvents();
    disableLazy = true;
  }
</script>

{#if user}
  <Page title={userTitle}>
    <Scroller>
      {#if message}
        <h3>{message}</h3>
      {/if}
      {#if events.length}
        <EventTable
          {events}
          project={params.project}
          mappings={[{ title: 'User', field: 'customFields.userId', enabled: false }]}
        />
        {#if !disableLazy}
          <Lazy offset={500} onload={onScrollEnded}>Loading...</Lazy>
        {/if}
      {/if}
    </Scroller>
  </Page>
{/if}
